<div class="row">
  <div class="col-xs-12 col-md-8 ">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    >
    </alertbox>
    <section>
      <h1>Solicitud de nueva contraseña</h1>
      <p> Introduzca sus datos y le enviaremos a su dirección de correo electrónico una contraseña nueva</p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Datos del usuario</h2>
          <fieldset>
            <legend class="sr-only">Formulario olvido clave</legend>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="poblacion"
                    class="slct"
                  >Población</label>
                  <div class="select">
                    <select
                      name="poblacion"
                      (change)="CambioPoblacion()"
                      [(ngModel)]="poblacion"
                      required
                    >
                      <option
                        *ngIf="explotaciones.length !== 1"
                        value="-1"
                        selected
                      >Seleccione una población</option>
                      <option
                        *ngFor="let explotacion of explotaciones; let i = index"
                        value={{i}}
                      >
                        {{explotacion.Descripcion}}</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="poblacionInputError == true"
                  class="error"
                >Introduzca un poblacion</span>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-3">
                <sacyr-input
                  [setType]="'dni'"
                  [setName]="'login'"
                  [setLabel]="'DNI'"
                  [setValue]="login"
                  [setRequired]="true"
                  [setError]="loginInputError"
                  (outValue)="login = $event"
                ></sacyr-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-6"></div>
              <div class="col-xs-12 col-sm-12 col-md-6">
                <re-captcha
                  #captchaRef="reCaptcha"
                  [(ngModel)]="formModel.captcha"
                  name="captcha"
                  required
                  siteKey="{{keyCapchasite}}"
                  #captchaControl="ngModel"
                >
                </re-captcha>
                <span
                  *ngIf="captchaError == true"
                  class="error"
                >Captcha debe ser resuelto</span>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </section>

    <div class="input-form input-button">
      <button
        type="submit"
        class="btn-default"
        (click)="resetPassword($event)"
        value=""
      >Enviar</button>
    </div>
  </div>
</div>
